import type { SuccessPhpResponse } from '@/types';
import Cookies from 'js-cookie';
import { ApiTracking, ApiFormEncoded, ApiJSON } from '@/api/insatances';
import Track from '@/utils/track';

export async function postQidGclidTracking(leadId?: string): Promise<void> {
  const qid = Cookies.get('QID');
  if (!qid || !leadId) return;
  try {
    const parsedQid = JSON.parse(qid);

    const formData = new URLSearchParams({
      gclid: parsedQid.gclid || '',
      leadId,
      via: window.location.href,
      gac: Cookies.get('_gac_UA-56929464-1') || '',
      ua: navigator.userAgent,
      qid,
    });

    return await ApiTracking.post('/qid-gclid-tracking.php', formData);
  } catch (error) {
    Track.Error.PostFailed('postQidGclidTracking');
    throw error;
  }
}

export async function postSuccessPhp(data: URLSearchParams): Promise<void> {
  try {
    return await ApiFormEncoded.post('/php/success.php', data, { timeout: 15000 });
  } catch (error) {
    Track.Error.PostFailed('postSuccessPhp');
    throw error;
  }
}

type Questionnaire = Record<string, string>;
type PostDataRequired = {
  agb_version: string;
  dynamicLandingPage: number;
  dynamicLandingPagePercent: [number, number, number, number];
  prioCalculatorV2: number;
  prioCalculatorV3: number;
  selectedCalculatorVersion: number;
  via: string;
};
type PostData = {
  [K in keyof PostDataRequired]: PostDataRequired[K];
} & Record<string, string | number | number[]>;
type PostSuccessPhpData = Questionnaire | { additional_answers: Questionnaire; post_data: PostData };
type PostSuccessPhpParams = {
  leadId: string;
  testVariation: string;
  forcedPriorityFour: boolean;
  // 'iusta' | 'crm', from GeneralSlice.selectors.leadPlatform (set from the initial submit's
  // response). Optional so older callers/tests that don't pass it still compile.
  leadPlatform?: string;
  // Iusta caseId once a previous questionnaire response returned one; lets PHP skip the case lookup.
  iustaCaseId?: string;
};
export async function postSuccessPhpWithParams(
  data: PostSuccessPhpData,
  params: PostSuccessPhpParams,
): Promise<SuccessPhpResponse | undefined> {
  try {
    const response = await ApiJSON.post('/php/success.php', data, { params: { update_lead: 1, ...params } });
    return response?.data;
  } catch (error) {
    Track.Error.PostFailed('postSuccessPhpWithParams');
    throw error;
  }
}

type PostSendFeedbackMail = {
  name: string;
  email: string;
  phone: string;
  message: string;
  secret: string;
};
export async function postSendFeedbackMail(data: PostSendFeedbackMail): Promise<void> {
  try {
    return await ApiJSON.post('/php/send-feedback-mail.php', data);
  } catch (error) {
    Track.Error.PostFailed('postSendFeedbackMail');
    throw error;
  }
}
